import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgEdit32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M26.968 9.437 25.5 10.905l-.793-.793L24 9.405l-1.293-1.293L22 7.405l-.793-.793 1.468-1.468a.492.492 0 0 1 .702.002l3.588 3.589a.493.493 0 0 1 .003.702M13.517 22.889V21.3L24 10.819l.794.794zM8.66 19.61h1.868v2.01h1.989v1.826l-6.162 2.31zm4.123 1.01h-1.255v-1.33L22 8.819l1.293 1.293zM20.5 7.32l.793.793-10.5 10.499H9.209zm7.172.709-3.588-3.59a1.498 1.498 0 0 0-2.116-.001L20.5 5.905l-.353.353-12 12v.002a.496.496 0 0 0-.115.176l-3 8a.499.499 0 0 0 .644.644l8-3a.512.512 0 0 0 .176-.117l.003.003 12.353-12.353-.001-.001 1.468-1.468a1.499 1.499 0 0 0-.003-2.116" className="edit-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgEdit32);
export default Memo;